// extracted by mini-css-extract-plugin
export var container = "styles-module__container___jr6HK";
export var saveToListTitle = "styles-module__saveToListTitle___xMJ39";
export var closeButton = "styles-module__closeButton___Hsap_";
export var tableWrapper = "styles-module__tableWrapper___zKU0s";
export var table = "styles-module__table___aahSV";